/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_GreetingInputs */

const en_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi there!`)
};

const ar_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا!`)
};

const bn_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাই!`)
};

const de_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo!`)
};

const es_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Hola!`)
};

const fr_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour !`)
};

const pt_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá!`)
};

const zh_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你好！`)
};

const tr_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba!`)
};

const ru_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет!`)
};

const pl_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cześć!`)
};

/**
* | output |
* | --- |
* | "Hi there!" |
*
* @param {Chat_GreetingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_greeting = /** @type {((inputs?: Chat_GreetingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_GreetingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_greeting(inputs)
	if (locale === "bn") return bn_chat_greeting(inputs)
	if (locale === "de") return de_chat_greeting(inputs)
	if (locale === "es") return es_chat_greeting(inputs)
	if (locale === "fr") return fr_chat_greeting(inputs)
	if (locale === "pt") return pt_chat_greeting(inputs)
	if (locale === "zh") return zh_chat_greeting(inputs)
	if (locale === "tr") return tr_chat_greeting(inputs)
	if (locale === "ru") return ru_chat_greeting(inputs)
	if (locale === "pl") return pl_chat_greeting(inputs)
	return en_chat_greeting(inputs)
});